// Generated by purs version 0.13.8
"use strict";
var Control_Category = require("../Control.Category/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Lunarbox_Data_Editor_Class_Depends = require("../Lunarbox.Data.Editor.Class.Depends/index.js");
var Lunarbox_Data_Graph = require("../Lunarbox.Data.Graph/index.js");
var GraphRep = function (toGraph) {
    this.toGraph = toGraph;
};
var toGraph = function (dict) {
    return dict.toGraph;
};
var graphRepGraph = new GraphRep(Control_Category.identity(Control_Category.categoryFn));
var graphRepDependencyMap = function (dictOrd) {
    return function (dictDepends) {
        return new GraphRep(function (functions) {
            var go = function ($$function) {
                return Data_Tuple.Tuple.create($$function)(Lunarbox_Data_Editor_Class_Depends.getDependencies(dictDepends)($$function));
            };
            return Lunarbox_Data_Graph.invert(dictOrd)(Lunarbox_Data_Graph.Graph(Data_Functor.map(Data_Map_Internal.functorMap)(go)(functions)));
        });
    };
};
module.exports = {
    toGraph: toGraph,
    GraphRep: GraphRep,
    graphRepDependencyMap: graphRepDependencyMap,
    graphRepGraph: graphRepGraph
};
